import { IValidate } from "../../interfaces/IValidate";
import { BaseValidator } from "./BaseValidator";
import { ValidationResultEnum } from "../enums/ValidationResult";
import { inputResult } from "../helpers/inputResult";
import { IValidationProperties } from "../../interfaces/IValidationProperties";

export class CollectionValidator extends BaseValidator implements IValidate {
    constructor(validationProperties: IValidationProperties) {
        super(validationProperties);
    }

    validate(value: any): inputResult {

        if (this.validationProperties.isRequired && !(value?.length > 0)) {
            return this.handle({ inputResult: { error: "Field is required", value: (value || "") }, validationResult: ValidationResultEnum.FieldIsRequired });
        }

        return super.validate(value);
    }
}